import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Team',
    href: '#team'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6
  }} className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0A0A0A]/95 backdrop-blur-md shadow-sm py-4' : 'bg-[#0A0A0A]/80 backdrop-blur-sm py-6'}`} data-id="element-151">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-152">
        <div className="flex justify-between items-center" data-id="element-153">
          <a href="#" className="flex items-center space-x-2 group" data-id="element-154">
            <img src="https://cdn.magicpatterns.com/uploads/pcqrDeDJVx53etCUm8aC8r/nobgnew1.png" alt="SGHarem Logo" className="h-10 w-auto object-contain" data-id="element-155" />
            <span className="text-2xl font-semibold text-[#F5F0EB]" data-id="element-156">
              SGHarems.com 新加坡后宫网
            </span>
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-157">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-[#F5F0EB] hover:text-[#D4AF37] transition-colors text-sm uppercase tracking-wider font-medium" data-id="element-158">
                {link.name}
              </a>)}
            <a href="#contact" className="bg-[#D4AF37] text-[#0A0A0A] px-6 py-2.5 rounded-sm hover:bg-[#F0D060] transition-colors duration-300 text-sm uppercase tracking-wider font-medium" data-id="element-159">
              Book Now
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-160">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-[#F5F0EB] hover:text-[#D4AF37] transition-colors" data-id="element-161">
              {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-162" /> : <Menu className="w-6 h-6" data-id="element-163" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-164">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-[#0A0A0A] border-t border-[#2A2A2A]" data-id="element-165">
            <div className="px-4 pt-2 pb-6 space-y-1 shadow-lg" data-id="element-166">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-4 text-base font-medium text-[#F5F0EB] hover:text-[#D4AF37] hover:bg-[#111111] rounded-sm transition-colors" data-id="element-167">
                  {link.name}
                </a>)}
              <a href="#contact" onClick={() => setIsMobileMenuOpen(false)} className="block w-full text-center mt-4 bg-[#D4AF37] text-[#0A0A0A] px-6 py-3 rounded-sm hover:bg-[#F0D060] transition-colors duration-300 font-medium" data-id="element-168">
                Book Now
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.nav>;
}